var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress, Paper } from '@material-ui/core';
import cx from 'clsx';
import Downshift from 'downshift';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Subject } from 'rxjs';
import { detectMessage } from './detect-message';
import { IncrementalSearch, now } from './IncrementalSearch';
import { renderInput, renderSuggestion } from './renderer';
export function Search(_a) {
    var search = _a.search, onSearched = _a.onSearched, onClick = _a.onClick, searchWaitMs = _a.searchWaitMs, resultMessage = _a.resultMessage;
    var _b = useState(false), menuIsOpen = _b[0], setMenuIsOpen = _b[1];
    var _c = useState(), submit$ = _c[0], setSubmit$ = _c[1];
    var timer = useRef(null);
    useEffect(function () {
        var s = new Subject();
        // s.next(now())
        setSubmit$(s);
        return function () { return s.unsubscribe(); };
    }, []);
    useEffect(function () {
        return function () {
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
    }, []);
    // const updateValue = setValue
    var reducer = function (state, changes) {
        // console.log(state, changes)
        switch (changes.type) {
            case Downshift.stateChangeTypes.changeInput: {
                var open_1 = !changes.inputValue || changes.inputValue.length < 2 ? false : true;
                setMenuIsOpen(open_1);
                return __assign(__assign({}, changes), { isOpen: open_1 });
            }
            case Downshift.stateChangeTypes.blurInput:
            case Downshift.stateChangeTypes.mouseUp:
                return __assign(__assign({}, changes), { inputValue: state.inputValue, isOpen: state.isOpen });
            case Downshift.stateChangeTypes.keyDownEnter:
                return __assign(__assign({}, changes), { inputValue: state.inputValue });
            default:
                return changes;
        }
    };
    var handleSubmit = useCallback(function (e) {
        e.preventDefault();
        setMenuIsOpen(true);
        setTimeout(function () {
            if (submit$) {
                submit$.next(now());
            }
        }, 100);
        // console.log('submit')
    }, [submit$]);
    var handleOuterClick = useCallback(function () {
        if (timer.current !== null) {
            window.clearTimeout(timer.current);
        }
        timer.current = window.setTimeout(function () { return setMenuIsOpen(false); }, 150);
    }, []);
    var handleSelect = function (item, state, queryFAQ) {
        if (!item) {
            return;
        }
        onSearched(state.inputValue || '', queryFAQ);
        onClick("/answer/".concat(item.id, "?query=").concat(encodeURIComponent((state === null || state === void 0 ? void 0 : state.inputValue) || '')));
    };
    return (_jsx(Downshift, { id: "downshift-simple", isOpen: menuIsOpen, onOuterClick: handleOuterClick, stateReducer: reducer, itemToString: function (item) { return (item === null || item === void 0 ? void 0 : item.title) || ''; }, children: function (_a) {
            var getInputProps = _a.getInputProps, getItemProps = _a.getItemProps, getMenuProps = _a.getMenuProps, highlightedIndex = _a.highlightedIndex, isOpen = _a.isOpen, inputValue = _a.inputValue;
            return (_jsxs("form", { className: "faq-search-container", onSubmit: handleSubmit, children: [renderInput({
                        InputProps: getInputProps({
                            placeholder: '質問内容をご入力ください',
                        }),
                    }), _jsx("div", __assign({}, getMenuProps(), { children: isOpen && submit$ ? (_jsx(IncrementalSearch, { inputValue: inputValue || '', "submit$": submit$, search: search, searchWaitMs: searchWaitMs, onSearched: onSearched, children: function (_a) {
                                var data = _a.data, done = _a.done, error = _a.error;
                                if (!data || !data.queryFAQ) {
                                    return _jsx(_Fragment, {});
                                }
                                if (data.queryFAQ.length === 0 && !!inputValue) {
                                    return done ? (_jsx(Paper, { className: cx('faq-search-result', 'faq-search-container__paper'), square: true, children: _jsx("p", { className: "faq-search-result__message", children: detectMessage(error, resultMessage) }) })) : (_jsx(Paper, { className: cx('faq-search-result', 'faq-search-container__paper'), square: true, children: _jsx(LinearProgress, { className: "faq-search-container__paper__progress" }) }));
                                }
                                var _b = data.queryFAQ, queryFAQ = _b === void 0 ? [] : _b;
                                return (_jsx(Paper, { className: cx('faq-search-result', 'faq-search-container__paper'), square: true, children: queryFAQ.map(function (suggestion, index) {
                                        return renderSuggestion({
                                            suggestion: suggestion,
                                            index: index,
                                            highlightedIndex: highlightedIndex,
                                            inputValue: inputValue,
                                            itemProps: getItemProps({
                                                item: suggestion,
                                            }),
                                            onClick: function (item) { return handleSelect(item, { inputValue: inputValue }, queryFAQ); },
                                        });
                                    }) }));
                            } })) : null }))] }));
        } }));
}
//# sourceMappingURL=Search.js.map